module.exports = __webpack_public_path__ + "static/install-attribution-fraud-06ff4c6510fb7b2f66a9716b34c84439.gif";